import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './shared/ui/globals.css';
import './shared/i18n/config';

async function enableMocksIfE2E(): Promise<void> {
  if (!import.meta.env.VITE_E2E) return;
  const { worker } = await import('./shared/api-client/mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass', quiet: true });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

void enableMocksIfE2E().then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
